import React from 'react'
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;
const rangePresets = [
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
];
const DateRangePicker = (props) => {
    const {value, className} = props;
    return (
        <RangePicker
            value={value}
            presets={rangePresets}
            onChange={props.onChange}
            className={className}
        />
    )
}
export default DateRangePicker